import { createAction, props } from '@ngrx/store';
import {
  Comment,
  HomepageRisksDome,
  SystemSecurityScore,
  Task,
  TaskDetails,
} from 'projects/shared/src/lib/core/interfaces';
import { baseProps } from 'projects/shared/src/lib/core/store/actions-base';

export const fetchHomeSystemSecurityScore = createAction(
  '[@diso/home] fetchHomeSystemSecurityScore',
  baseProps(),
);

export const fetchHomeSystemSecurityScoreSuccess = createAction(
  '[@diso/home] fetchHomeSystemSecurityScoreSuccess',
  baseProps<{ systemSecurityScore: SystemSecurityScore }>(),
);

export const fetchHomeSystemSecurityScoreFailure = createAction(
  '[@diso/home] fetchHomeSystemSecurityScoreFailure',
);

export const fetchHomeTasks = createAction(
  '[@diso/home] fetchHomeTasks',
  baseProps(),
);

export const fetchHomeTasks_Success = createAction(
  '[@diso/home] fetchHomeTasks_Success',
  props<{ tasks: Task[] }>(),
);

export const fetchHomeTasks_Failure = createAction(
  '[@diso/home] fetchHomeTasks_Failure',
);

export const fetchHomeTaskDetails = createAction(
  '[@diso/home] fetchHomeTaskDetails',
  baseProps<{ taskId: string }>(),
);

export const fetchHomeTaskDetails_Success = createAction(
  '[@diso/home] fetchHomeTaskDetails_Success',
  props<{ taskDetails: TaskDetails }>(),
);

export const fetchHomeTaskDetails_Failure = createAction(
  '[@diso/home] fetchHomeTaskDetails_Failure',
);

export const removeHomeTaskDetailsSidebar = createAction(
  '[@diso/home] removeHomeTaskDetailsSidebar',
);

export const toggleHomeTaskSidebar = createAction(
  '[@diso/home] toggleHomeTaskSidebar',
  props<{ showSidebar: boolean }>(),
);

export const addHomeTaskComment = createAction(
  '[@diso/home] addHomeTaskComment',
  props<{ taskId: string; commentText: string }>(),
);

export const addHomeTaskComment_Success = createAction(
  '[@diso/home] addHomeTaskComment_Success',
  props<{ comment: Comment; taskId: string }>(),
);

export const setHomeTaskDetailsCommentPending = createAction(
  '[@diso/home] setHomeTaskDetailsCommentPending',
  props<{ pending: boolean; taskId: string }>(),
);

export const setHomeTaskDetailsCommentFailed = createAction(
  '[@diso/home] setHomeTaskDetailsCommentFailed',
  props<{ failed: boolean; errorMessage?: string; taskId: string }>(),
);

export const resetHomeTasksStore = createAction(
  '[@diso/home] resetHomeTasksStore',
);

export const fetchHomeRisksDome = createAction('[@diso/home] fetchHomeRisksDome');

export const fetchHomeRisksDome_Success = createAction(
  '[@diso/home] fetchHomeRisksDome_Success',
  props<{ risksDome: HomepageRisksDome }>(),
);

export const fetchHomeRisksDome_Failure = createAction('[@diso/home] fetchHomeRisksDome_Failure');
